export const Colors = {
  backgroundColor: "#f5f5f5",
  primaryColor: "#0a3c46",
  babyBlue: "#007bff"
};